import { render, staticRenderFns } from "./advertiser-dialog-app.vue?vue&type=template&id=4e47b364"
import script from "./advertiser-dialog-app.vue?vue&type=script&lang=js"
export * from "./advertiser-dialog-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports